var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Houve um "),_c('b',[_vm._v("erro")]),_vm._v(" ao deletar o "),_c('b',[_vm._v("Banco!")]),_vm._v(" por favor, tente novamente. ")])}]

export { render, staticRenderFns }